<template>
  <v-dialog v-model="show" persistent max-width="500px">
    <v-card class="dialog-container">
      <v-container>
        <v-card-title primary-title>
          <span class="dialog-title">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <div>{{ content }}</div>
        </v-card-text>
      </v-container>
      <v-card-actions>
        <v-spacer />
        <main-button text="Cancel" style="margin-right: 12px" flat outline @click="closeDialog()" />
        <main-button
          :text="actionMessage || 'Delete'"
          color="error"
          @click="
            onDelete()
            closeDialog()
          "
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'delete-dialog',
  props: {
    show: Boolean,
    title: String,
    content: String,
    onDelete: Function,
    actionMessage: String,
  },
  methods: {
    closeDialog() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped>
.dialog-container {
  padding-bottom: 1.5rem !important;
  padding-right: 1.5rem !important;
}
</style>
